export const aSearchElements = [
  {
    label: '',
    name: 'branch_id',
    type: 'invisible',
  },
  {
    label: 'Folio',
    name: 'folio',
    type: 'input-int',
  },
];

export const oInitState = {
  folio: '',
};

export const requiredFields = true;
